import { RouteLocationNormalized } from "vue-router";

import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";
import { Permissions } from "@/modules/authorisation/enums";

export default function redirectIfNotPermitted(permission: Permissions, redirectToName: string) {
  return (to: RouteLocationNormalized) => {
    if (useAuthorisationStore().can(permission)) {
      return undefined;
    }
    return { name: redirectToName, params: to.params };
  };
}
